/**
 * kpiStatDisplay — pure display-logic helpers for KpiStatCard.
 *
 * Extracted from KpiStatCard.vue (cas-aabb) so the value formatting and the
 * ▲/▼ delta direction can be unit-tested against the golden dataset without
 * mounting the component. KpiStatCard.vue imports these; behaviour is identical
 * to the previous inline definitions.
 */

/**
 * Format a KPI value for display.
 *   >= 1,000,000,000 → "1.5B"
 *   >= 1,000,000 → "1.5M"
 *   >= 1,000     → "6.4K"
 *   otherwise    → locale-formatted integer ("1,024")
 * A `prefix` (e.g. "$") is prepended to numeric output. String values pass
 * through unchanged.
 */
export function formatKpiValue(value: string | number, prefix?: string): string {
  if (typeof value === 'string') return value;
  const n = value;
  let formatted: string;
  if (n >= 999_950_000) {
    formatted = `${(n / 1_000_000_000).toFixed(1)}B`;
  } else if (n >= 999_950) {
    formatted = `${(n / 1_000_000).toFixed(1)}M`;
  } else if (n >= 1_000) {
    formatted = `${(n / 1_000).toFixed(1)}K`;
  } else {
    formatted = n.toLocaleString();
  }
  return prefix ? `${prefix}${formatted}` : formatted;
}

/** Material icon for a delta: up/down for movement, flat for no change. */
export function kpiDeltaIcon(delta: number): 'trending_up' | 'trending_down' | 'trending_flat' {
  if (delta === 0) return 'trending_flat';
  return delta > 0 ? 'trending_up' : 'trending_down';
}

/** BEM modifier class for a delta: positive/negative for movement, none for neutral/no change. */
export function kpiDeltaClass(delta: number | undefined): string {
  if (delta === undefined) return '';
  if (delta === 0) return '';
  return delta > 0 ? 'kpi-stat-card__delta--positive' : 'kpi-stat-card__delta--negative';
}
